import { Box } from '@components/Box';
import { STATUS_CHECK_LABEL } from '@lib/utils/statuses';

import {
  AvailabilityButtonContainer,
  StyledButtonAvailCheck,
  StyledInvite,
  StyledText,
  Styledtext,
  StyledWarning,
} from '../styles';

type InvitedBoxSubmittedUsProps = {
  props: SubmissionDetails | SubmissionDetailsMisc;
  isMobileDevice: boolean;
  formattedDate: string;
  handleNoLongerAvailable: () => void;
  EditableSnippet: string;
};
export const InvitedBoxSubmittedUs = ({
  props,
  isMobileDevice,
  formattedDate,
  handleNoLongerAvailable,
  EditableSnippet,
}: InvitedBoxSubmittedUsProps) => {
  return (
    <div style={{ ...(isMobileDevice ? { padding: 16 } : {}) }}>
      <Box style={{ marginTop: !isMobileDevice && '16px', padding: '24px' }}>
        <div style={{ fontSize: '14px', fontWeight: 400, marginBottom: 16 }}>
          {formattedDate}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <StyledInvite>
            You are marked as “Available” for{' '}
            {props?.project_name +
              (props?.related_column_values?.Role
                ? ' | ' + props?.related_column_values?.Role
                : '')}
          </StyledInvite>
        </div>
        <StyledText>
          <StyledWarning> This is not currently a booking.</StyledWarning>
        </StyledText>
        <h5
          style={{
            fontSize: '14px',
            fontWeight: '400',
            marginBottom: '16px',
          }}
        >
          What can I expect?
        </h5>
        <Styledtext>
          {' '}
          If Casting intends to potentially book you, you will receive a
          notification asking to re-confirm your availability with &quot;
          {STATUS_CHECK_LABEL}&quot;. If you were not selected, it is unlikely
          that you will receive an update from casting, so please do not
          hesitate to submit for other work.
        </Styledtext>
        <Styledtext style={{ marginTop: '16px' }}>
          If your availability changes, update here:
        </Styledtext>

        <AvailabilityButtonContainer
          style={
            isMobileDevice
              ? { marginTop: '16px', width: '100%' }
              : { marginTop: '16px' }
          }
        >
          <StyledButtonAvailCheck
            style={{ opacity: props.is_archived && '0.4' }}
            disabled={props.is_archived}
            onClick={handleNoLongerAvailable}
          >
            No Longer Available
          </StyledButtonAvailCheck>
        </AvailabilityButtonContainer>

        {!!EditableSnippet && (
          <div
            style={{ marginTop: '16px' }}
            dangerouslySetInnerHTML={{ __html: EditableSnippet }}
          />
        )}
      </Box>
    </div>
  );
};
